__turbopack_context__.v({
  "BCorpSvg": "HKXh4W_BCorpSvg",
  "Badges": "HKXh4W_Badges",
  "Footer": "HKXh4W_Footer",
  "Legal": "HKXh4W_Legal",
  "MWLogo": "HKXh4W_MWLogo",
  "MainNav": "HKXh4W_MainNav",
  "Privacy": "HKXh4W_Privacy",
  "Social": "HKXh4W_Social",
  "SocialIcons": "HKXh4W_SocialIcons",
  "Swoop": "HKXh4W_Swoop",
  "SwoopPath": "HKXh4W_SwoopPath",
});
